import React from "react";
import { Reference, Skill } from "../types";
import ExperienceEntry from "./ExperienceEntry";

type Props = {
  experiences: Reference[];
  skills: Skill[];
  title: string;
  printBreak?: boolean;
};

export default function Experiences({
  experiences,
  skills,
  title,
  printBreak = false,
}: Props) {
  const allSkillItems = skills.flatMap((s) => s.items || []);

  return (
    <section className={printBreak ? "print-break-before" : ""}>
      <h2 className="section-label mb-6">{title}</h2>
      <div className="pl-1">
        {experiences.map((entry, i) => (
          <ExperienceEntry
            key={i}
            entry={entry}
            allSkillItems={allSkillItems}
            isLast={i === experiences.length - 1}
          />
        ))}
      </div>
    </section>
  );
}
